import {Component, inject} from '@angular/core';
import {GameStore} from '../../../store/game.store';

@Component({
    selector: 'gis-step',
    templateUrl: './steps.component.html',
    styleUrl: './steps.component.scss'
})
export class StepsComponent {
  protected store = inject(GameStore);
}
